module.exports = __webpack_public_path__ + "prod/1.42.2/img/system-two-h5.57b2934b.png";